export default "__VITE_ASSET__BfsGOrqX__"